import React, { useState } from 'react';
import './ApplicantScoresPage.css';

const dummyApplication = {
  applicantId: "rsmin-2025-001",
  name: "Tanya Redsky",
  status: "Pending",
  sections: [
    {
      label: "Career Goals",
      weight: 20,
      questions: [
        {
          label: "Describe your career goals and connection to community",
          answer: "I want to become a social worker...",
          aiScore: 18,
          aiRationale: "Shows strong alignment with community-based goals.",
          reviewerScore: null,
          reviewerComment: ""
        }
      ]
    },
    {
      label: "Community Engagement",
      weight: 30,
      questions: [
        {
          label: "How do you contribute to community development?",
          answer: "I volunteer at local shelters...",
          aiScore: 15,
          aiRationale: "Moderate community involvement.",
          reviewerScore: null,
          reviewerComment: ""
        }
      ]
    }
  ]
};

const ApplicantScoresPage = () => {
  const [application, setApplication] = useState(dummyApplication);

  const handleScoreChange = (sectionIdx, questionIdx, value) => {
    const updatedApp = { ...application };
    updatedApp.sections = updatedApp.sections.map((s, si) => {
      if (si !== sectionIdx) return s;
      return {
        ...s,
        questions: s.questions.map((q, qi) => {
          if (qi !== questionIdx) return q;
          return { ...q, reviewerScore: Number(value) };
        })
      };
    });
    setApplication(updatedApp);
  };

  const handleCommentChange = (sectionIdx, questionIdx, value) => {
    const updatedApp = { ...application };
    updatedApp.sections = updatedApp.sections.map((s, si) => {
      if (si !== sectionIdx) return s;
      return {
        ...s,
        questions: s.questions.map((q, qi) => {
          if (qi !== questionIdx) return q;
          return { ...q, reviewerComment: value };
        })
      };
    });
    setApplication(updatedApp);
  };

  const calculateTotalScore = () => {
    const total = application.sections.reduce((acc, section) => {
      const sectionScore = section.questions.reduce((sqAcc, q) => {
        const score = q.reviewerScore !== null ? q.reviewerScore : q.aiScore;
        return sqAcc + score;
      }, 0);
      const avg = section.questions.length ? sectionScore / section.questions.length : 0;
      return acc + avg * (section.weight / 100);
    }, 0);

    return Number(total).toFixed(2);
  };

  const handleSubmitScores = async () => {
    // TODO: replace with API POST
    console.log('Submitting scores payload', application);
    alert('Scores submitted (dummy).');
  };

  const handleApprove = async () => {
    // TODO: call API to set status to approved
    alert('Application Approved (dummy)');
  };

  const handleDecline = async () => {
    // TODO: call API to set status to declined
    alert('Application Declined (dummy)');
  };

  return (
    <div className="p-6 max-w-4xl mx-auto bg-gray-50">
      <header className="mb-6">
        <h1 className="text-2xl font-bold">Applicant Scoring</h1>
        <p className="mt-1 text-gray-700">
          Name: <span className="font-semibold">{application.name}</span> | ID: <span className="font-semibold">{application.applicantId}</span>
        </p>
        <p className="mt-1 text-gray-700">Status: <span className="font-semibold">{application.status}</span></p>
      </header>

      {application.sections.map((section, sIdx) => (
        <div key={sIdx} className="mb-8 p-4 bg-white shadow rounded">
          <div className="mb-4 border-b pb-2">
            <h2 className="text-xl font-semibold">{section.label}</h2>
            <p className="text-sm text-gray-600">Weight: {section.weight}%</p>
          </div>

          {section.questions.map((question, qIdx) => (
            <div key={qIdx} className="mb-6 border p-4 rounded">
              <h3 className="text-lg font-medium">{question.label}</h3>
              <p className="mt-1 text-gray-800"><span className="font-semibold">Answer: </span>{question.answer}</p>
              <div className="mt-2">
                <p className="text-sm text-gray-700">
                  <span className="font-semibold">AI Score: </span>{question.aiScore} &mdash;
                  <span className="italic"> {question.aiRationale}</span>
                </p>
              </div>

              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Override Score:</label>
                <input
                  type="range"
                  min="0"
                  max="20"
                  step="1"
                  value={question.reviewerScore !== null ? question.reviewerScore : question.aiScore}
                  onChange={(e) => handleScoreChange(sIdx, qIdx, e.target.value)}
                  className="w-full"
                />
                <span className="text-sm text-gray-600">{question.reviewerScore !== null ? question.reviewerScore : question.aiScore}</span>
              </div>

              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Reviewer Comments:</label>
                <textarea
                  value={question.reviewerComment}
                  onChange={(e) => handleCommentChange(sIdx, qIdx, e.target.value)}
                  className="w-full border rounded p-2"
                  rows="3"
                  placeholder="Enter your comments here..."
                />
              </div>
            </div>
          ))}
        </div>
      ))}

      <div className="mt-6 p-4 bg-white shadow rounded">
        <div className="mb-4">
          <p className="text-lg font-bold text-gray-800">Total Weighted Score: {calculateTotalScore()}</p>
        </div>
        <div className="flex space-x-4">
          <button onClick={handleSubmitScores} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Submit Scores</button>
          <button onClick={handleApprove} className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">Approve</button>
          <button onClick={handleDecline} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">Decline</button>
        </div>
      </div>
    </div>
  );
};

export default ApplicantScoresPage;
